export default {
  path: '/interview/review',
  title: ' 新闻宣传',
  icon: 'microphone',
  hideSub: false,
  children: (pre => [
    {
      title: '提交申请',
      icon: 'pencil',
      path: `${pre}apply`
    },
    {
      title: '申请审批',
      icon: 'list',
      path: `${pre}review`
    },
    {
      title: '任务认领',
      icon: 'cubes',
      path: `${pre}task`
    },
    {
      title: '日程安排',
      icon: 'calendar',
      path: `${pre}calendar`
    }
  ])('/interview/')
}
